<mat-dialog-content style="height : 65vh; text-align: center;">
  <h1>{{data.nome}}</h1>
  <img #image />
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button cdkFocusInitial [mat-dialog-close]="true">
    Confirmar
  </button>
</mat-dialog-actions>